// components/dashboard/credits/blocks/useJson.ts
'use client'

import { useEffect, useState } from 'react'

type State<T> =
  | { status: 'loading' }
  | { status: 'error'; message: string }
  | { status: 'ok'; data: T }

export function useJson<T>(url: string) {
  const [state, setState] = useState<State<T>>({ status: 'loading' })

  useEffect(() => {
    const ac = new AbortController()

    ;(async () => {
      try {
        setState({ status: 'loading' })
        const res = await fetch(url, { method: 'GET', cache: 'no-store', signal: ac.signal })
        if (res.status === 401) return setState({ status: 'error', message: 'UNAUTHENTICATED' })
        if (!res.ok) return setState({ status: 'error', message: `HTTP ${res.status}` })
        const json = (await res.json()) as any
        if (!json?.ok) return setState({ status: 'error', message: json?.error || 'API_NOT_OK' })
        setState({ status: 'ok', data: json as T })
      } catch (e: any) {
        if (e?.name === 'AbortError') return
        setState({ status: 'error', message: e?.message || 'FETCH_FAILED' })
      }
    })()

    return () => ac.abort()
  }, [url])

  return state
}
